var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "app-checkbox",
      class: { "app-checkbox--disabled": _vm.$attrs.disabled }
    },
    [
      _c(
        "input",
        _vm._b(
          {
            staticClass: "app-checkbox__input",
            attrs: { type: "checkbox", required: _vm.required },
            domProps: { checked: _vm.isChecked },
            on: { change: _vm.onChangeHandler }
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c("span", {
        staticClass: "app-checkbox__mark",
        class: { "app-checkbox__mark--selector": _vm.selector }
      }),
      _vm._v(" "),
      _c("div", [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77a7bb27", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77a7bb27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppCheckbox.vue
// module id = null
// module chunks = 